'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import type { BuilderSkill } from '@/modules/__generated__/graphql/switchboard-generated';
import { BuildersSkillsChip } from '@/modules/shared/components/chips/builders-skills-chip';
import { SkillsPopover } from './skills-popover';
export interface BuilderSkillsProps {
  skills: BuilderSkill[];
  className?: string;
}
function BuilderSkills(t0) {
  const $ = _c(7);
  const {
    skills,
    className
  } = t0;
  const handlePopoverClick = _temp;
  let t1;
  if ($[0] !== className) {
    t1 = cn("grid grid-cols-1 lg:gap-1", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== skills) {
    t2 = skills.slice(0, 2).map((skill, index) => <div key={skill} className={cn("flex gap-1", {
      "hidden lg:flex": index === 1
    })}><BuildersSkillsChip key={skill} skill={skill} /><div className={cn({
        "lg:hidden": index === 0 || index === 1 && skills.length === 2,
        hidden: skills.length === 1
      })} onClick={handlePopoverClick}><SkillsPopover skills={skills} /></div></div>);
    $[2] = skills;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(e) {
  e.preventDefault();
  e.stopPropagation();
}
export { BuilderSkills };